import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Clock, Smartphone, Brain, BatteryWarning } from 'lucide-react';
export function Problem() {
  return <section className="py-20 px-6 bg-white/50" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <FadeIn data-id="element-111">
          <div className="prose prose-lg prose-stone mx-auto mb-20" data-id="element-112">
            <p className="font-serif text-2xl md:text-3xl leading-relaxed text-[#1C1917] mb-8" data-id="element-113">
              Abrir los ojos y sentir, en menos de tres segundos, una presión en
              el pecho. Revisar el teléfono y dejar que el estrés de otros dicte
              tu humor hasta la noche.
            </p>
            <p className="text-[#4A4541] text-lg" data-id="element-114">
              Si te sientes atropellado por tu propia agenda antes de salir de
              la cama, no es falta de disciplina. Es un secuestro biológico de
              tu cerebro.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-115">
          <h2 className="font-serif text-3xl md:text-4xl mb-6 text-[#1C1917]" data-id="element-116">
            La mayoría de las personas viven en un estado de "reacción
            perpetua".
          </h2>
          <p className="text-[#4A4541] text-lg mb-6 leading-relaxed" data-id="element-117">
            Despiertan con un pico de cortisol agresivo y se acuestan con una
            mente que se niega a apagarse, repasando conversaciones del pasado y
            problemas que aún no ocurren.
          </p>
          <p className="text-[#4A4541] text-lg mb-16 leading-relaxed" data-id="element-118">
            Intentas meditar, pero tu mente grita. Usas apps genéricas, pero te
            aburres a los dos minutos. El resultado es el mismo: agotamiento
            crónico, niebla mental y la sensación de que el día te pertenece a
            todos, menos a ti.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-119">
          <h3 className="font-serif text-2xl mb-8 text-[#1C1917] border-b border-[#E5E0D8] pb-4" data-id="element-120">
            Por qué lo que has intentado no funciona
          </h3>
          <div className="space-y-6" data-id="element-121">
            <div className="flex gap-4" data-id="element-122">
              <Clock className="w-6 h-6 text-[#C26D5C] shrink-0 mt-1" strokeWidth={1.5} data-id="element-123" />
              <p className="text-[#4A4541] text-lg" data-id="element-124">
                Las meditaciones de 20 minutos son imposibles de encajar en una
                rutina real y ocupada.
              </p>
            </div>
            <div className="flex gap-4" data-id="element-125">
              <Smartphone className="w-6 h-6 text-[#C26D5C] shrink-0 mt-1" strokeWidth={1.5} data-id="element-126" />
              <p className="text-[#4A4541] text-lg" data-id="element-127">
                Las apps de mindfulness ignoran que tu cerebro necesita
                activación por la mañana y sedación por la noche.
              </p>
            </div>
            <div className="flex gap-4" data-id="element-128">
              <Brain className="w-6 h-6 text-[#C26D5C] shrink-0 mt-1" strokeWidth={1.5} data-id="element-129" />
              <p className="text-[#4A4541] text-lg" data-id="element-130">
                Intentar "poner la mente en blanco" solo genera más frustración
                cuando estás bajo altos niveles de estrés.
              </p>
            </div>
            <div className="flex gap-4" data-id="element-131">
              <BatteryWarning className="w-6 h-6 text-[#C26D5C] shrink-0 mt-1" strokeWidth={1.5} data-id="element-132" />
              <p className="text-[#4A4541] text-lg font-medium text-[#1C1917]" data-id="element-133">
                No necesitas más espiritualidad mística, necesitas una
                estrategia de supervivencia biológica.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}